if (document.querySelector('.main-block__bg')) {
    var moveRight = anime({
        targets: '.main-block__bg',
        width: 0,
        easing: 'easeOutQuad',
        duration: 900
    });
}
if (document.querySelector('.main-block__title span')) {
    var title = anime({
        targets: '.main-block__title span',
        translateY: -80,
        easing: 'easeOutQuad',
        opacity: 1,
        duration: 800,
        delay: anime.stagger(100, {
            start: 750
        })
    });
}
if (document.querySelector('.main-block__description ul')) {
    var description = anime({
        targets: '.main-block__description ul',
        translateY: -80,
        easing: 'easeOutQuad',
        opacity: 1,
        duration: 800,
        delay: 1200
    });
}
if (document.querySelector('.header div')) {
    var header = anime({
        targets: '.header div',
        translateY: 20,
        easing: 'easeOutQuad',
        opacity: 1,
        duration: 800,
        delay: anime.stagger(100, {
            start: 2000
        })
    });
}
if (document.querySelector('.preload-red')) {
    var btnRed = anime({
        targets: '.preload-red',
        easing: 'easeOutQuad',
        width: '424px',
        duration: 800,
        delay: 1800
    });
}
if (document.querySelector('.download-btn')) {
    var download = anime({
        targets: '.download-btn',
        easing: 'easeOutQuad',
        width: '424px',
        duration: 800,
        delay: 1900
    });
}
if (document.querySelector('.download-btn__text')) {
    var textBtn = anime({
        targets: '.download-btn__text',
        easing: 'easeOutQuad',
        opacity: 1,
        duration: 2000,
        delay: 2800
    });
}
$('.download-btn').hover(function () {
    $('.preload-red').css('display', 'none');
});

function is_shown(target) {
    var wt = $(window).scrollTop();
    var wh = $(window).height();
    var eh = $(target).outerHeight();
    var et = $(target).offset().top;
    if (wt + wh >= et && wt + wh - eh * 2 <= et + (wh - eh)) {
        // if(wt > et-500){
        return true;
    } else {
        return false;
    }
}

sectAdvantages = false;
sectSlider = false;
sectNews = false;
sectProjects = false;
sectAbout = false;
sectSlider = false;
sectMap = false;
$(window).scroll(function () {
    if (document.querySelector('.news')) {
        if (is_shown('.news') && !sectNews) {
            sectNews = true;
            var newsUl = anime({
                targets: ['.news__title', '.news__breadcrums'],
                translateY: '-40px',
                easing: 'easeOutQuad',
                opacity: 1,
                duration: 800,
                delay: anime.stagger(200, {
                    start: 200
                })
            });
            var news = anime({
                targets: ['.news__main-news', '.news__img'],
                easing: 'easeOutQuad',
                width: '100%',
                duration: 1000,
                delay: anime.stagger(600)
            });
            if ($(window).width() > '900') {
                var news2 = anime({
                    targets: '.news__img',
                    easing: 'easeOutQuad',
                    minWidth: '384px',
                    duration: 1000,
                    delay: 600
                });
            } else {
                var news2 = anime({
                    targets: '.news__img',
                    easing: 'easeOutQuad',
                    minMidth: '100%',
                    duration: 1000,
                    delay: 800
                });
            }
            var otherNews = anime({
                targets: '.news__block',
                translateY: '-40px',
                easing: 'easeOutQuad',
                opacity: 1,
                duration: 600,
                delay: anime.stagger(200, {
                    start: 1000
                })
            });
            var newsContent = anime({
                targets: '.news__main-news-content',
                translateY: '-40px',
                easing: 'easeOutQuad',
                opacity: 1,
                duration: 600,
                delay: 1450
            });
        }
    }
    
    if (document.querySelector('.advantages')) {
        if (is_shown('.advantages') && !sectAdvantages) {
            sectAdvantages = true;
            if ($(window).width() > '900') {
                var adv = anime({
                    targets: '.advantages',
                    easing: 'easeOutQuad',
                    width: '100%',
                    opacity: 1,
                    paddingLeft: '94px',
                    duration: 800,
                    delay: 600
                });
            } else {
                var adv = anime({
                    targets: '.advantages',
                    easing: 'easeOutQuad',
                    width: '100%',
                    paddingLeft: '18px',
                    duration: 800,
                    opacity: 1,
                    delay: 600
                });
            }
            ;
            var advDiv = anime({
                targets: ['.advantages__header', '.advantages__row'],
                easing: 'easeOutQuad',
                translateY: '-20px',
                opacity: 1,
                duration: 800,
                delay: anime.stagger(200, {
                    start: 1000
                })
            });
            if ($(window).width() > '900') {
                var bg = anime({
                    targets: '.bg-r',
                    easing: 'easeOutQuad',
                    width: '72px',
                    duration: 600,
                    delay: 1800
                });
            } else {
                var bg = anime({
                    targets: '.bg-r',
                    easing: 'easeOutQuad',
                    width: '16px',
                    duration: 400,
                    delay: 1800
                });
            }
            ;
        }
    }

    
    if (document.querySelector('.projects')) {
        if (is_shown('.projects') && !sectProjects) {
            sectProjects = true;
            var Projectswiper = new Swiper('.project-slider .swiper-container', {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
            var projectHead = anime({
                targets: '.projects-head',
                translateY: '-40px',
                easing: 'linear',
                opacity: 1,
                duration: 600,
                delay: 400
            });
            var projects1 = anime({
                targets: '.projects__bg-image',
                easing: 'linear',
                width: '100%',
                duration: 500,
                delay: 600
            });
            var projects1 = anime({
                targets: '.projects__bg-filter',
                easing: 'linear',
                width: '100%',
                duration: 500,
                delay: 600
            });
            var projects5 = anime({
                targets: '.projects__title',
                easing: 'linear',
                translateY: '-40px',
                opacity: 1,
                duration: 800,
                delay: 2000
            });
            var projects7 = anime({
                targets: '.swiper-button-next, .swiper-button-prev',
                easing: 'linear',
                opacity: 1,
                duration: 800,
                delay: 2000
            });
            if ($(window).width() < '900') {
                var projects9 = anime({
                    targets: '.projects__text',
                    easing: 'linear',
                    opacity: 1,
                    duration: 800,
                    delay: 2000
                });
            }
            ;
        }
    }
    
    if (document.querySelector('.about')) {
        if (is_shown('.about') && !sectAbout) {
            sectAbout = true;
            var about1 = anime({
                targets: '.about__left',
                translateY: '-80px',
                easing: 'linear',
                opacity: 1,
                duration: 600,
                delay: 800
            });
            var about2 = anime({
                targets: '.about__right',
                translateY: '-80px',
                easing: 'linear',
                opacity: 1,
                duration: 600,
                delay: 950
            });
            var aboutLogo = anime({
                targets: '.about img',
                translateY: '-60px',
                easing: 'linear',
                opacity: 1,
                duration: 800,
                delay: 900
            });
        }
    }
    
    if (document.querySelector('.slider')) {
        if (is_shown('.slider') && !sectSlider) {
            sectSlider = true;
            var offset = new Array();
            var parentOffset = $(".slider__content ul").position().top + parseInt($(".slider__content ul").css('margin-top').replace("px"));
            $(".slider__content ul li").each(function (index) {
                offset.push($(this).position().top - parentOffset);
            });
            var mySwiper = new Swiper('.slider .swiper-container', {
                speed: 2200,
                fadeEffect: {
                    crossFade: true
                },
                effect: 'fade',
                autoplay: {
                    delay: 2200,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    renderBullet: function (index, className) {
                        return '<span class=' + className + '><svg class="circ" width="30" height="30"><circle class="circ1" cx="15" cy="15" r="14" stroke="#fff" stroke-width="2" fill="none"></circle><circle class="circ1" cx="15" cy="15" r="2" stroke="none" fill="#fff"></circle></svg></span>';
                    }
                },
            });
            var i = 0;
            $(".swiper-pagination-bullets span").each(function (index) {
                $(this).css("position", "absolute");
                $(this).css("top", offset[i] + "px");
                i++;
            });
            $(function () {
                function StartSlider(slide) {
                    timeoutId = null;
                    mySwiper.slideTo(slide.index(), 2200);
                    mySwiper.autoplay.stop();
                }
    
                var timeoutId;
                $('.slider__content li').hover(function () {
                    if (!timeoutId) {
                        timeoutId = window.setTimeout(StartSlider, 600, $(this));
                    }
                }, function () {
                    if (timeoutId) {
                        window.clearTimeout(timeoutId);
                        timeoutId = null;
                    } else {
                        mySwiper.autoplay.start();
                    }
                });
            });
            var slider = anime({
                targets: '.slider',
                easing: 'easeOutQuad',
                width: '100%',
                opacity: 1,
                duration: 1000,
                delay: 800
            });
    
            if ($(window).width() > '900') {
                var slider1 = anime({
                    targets: '.fitch',
                    easing: 'easeOutQuad',
                    left: 'calc(100% - 488px)', // right: 0,                // paddingLeft: '64px',
                    duration: 500,
                    delay: 500
                });
                var slider1 = anime({
                    targets: '.fitch',
                    easing: 'easeOutQuad',
                    width: '488px',
                    opacity: 1,
                    duration: 1000,
                    delay: 1800
                });
            }
            if  ($(window).width() < '1025' &&  $(window).width() >'900'){
                var slider11 = anime({
                    targets: '.fitch',
                    easing: 'easeOutQuad',
                    left: 'calc(100% - 460px)', // right: 0,                // paddingLeft: '64px',
                    duration: 500,
                    delay: 500
                });
                var slider12 = anime({
                    targets: '.fitch',
                    easing: 'easeOutQuad',
                    width: '460px',
                    opacity: 1,
                    duration: 1000,
                    delay: 1800
                });
            }
            if ($(window).width() < '900'){
    
                var slider1 = anime({
                    targets: '.fitch',
                    easing: 'easeOutQuad',
                    width: 'auto',
                    paddingLeft: '32px',
                    duration: 1000,
                    delay: 1800
                });
                var slider1 = anime({
                    targets: '.fitch',
                    easing: 'easeOutQuad',
                    left: 0,
                    opacity: 1,
                    duration: 1000,
                    delay: 1900
                });
            }
    
            var about3 = anime({
                targets: '.fitch__elem',
                translateY: '-40px',
                easing: 'linear',
                opacity: 1,
                duration: 600,
                delay: 2500
            });
            var about7 = anime({
                targets: '.fitch__block_bot',
                translateY: '-40px',
                easing: 'linear',
                opacity: 1,
                duration: 600,
                delay: 2900
            });
            // var about4 = anime({
            //     targets: '.fitch__links',
            //     translateY: '-40px',
            //     easing: 'linear',
            //     opacity: 1,
            //     duration: 600,
            //     delay: 2700
            // });
    
        }
    }
    
    if (document.querySelector('.map-wrapper')) {
        if (is_shown('.map-wrapper') && !sectMap) {
            sectMap = true;
            var Map = anime({
                targets: '.map',
                easing: 'linear',
                opacity: 1,
                duration: 1200,
                delay: 400
            });
            var Map1 = anime({
                targets: '.map__title',
                translateY: '-20px',
                easing: 'linear',
                opacity: 1,
                duration: 800,
                delay: 400
            });
            var Map2 = anime({
                targets: '.map__tabs',
                translateY: '-20px',
                easing: 'linear',
                opacity: 1,
                duration: 800,
                delay: 400
            });
        }
    }
});
var body = $('#body');
$('.mobile-menu-btn').click(function () {
    $('.mobile-menu').addClass('is-active');
    body.addClass('no-scroll');
});
$('.mobile-menu__close').click(function () {
    $('.mobile-menu').removeClass('is-active');
    body.removeClass('no-scroll');
});  //canvas линии для блока advantages

"use strict";

function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!_instanceof(instance, Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}

function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

var canvas,
    ctx,
    lines = [],
    timeout,
    isMoving = false,
    mouse = {
        'x': 0,
        'y': 0
    },
    windowWidth = $(window).width(),
    windowHeight = $(window).height();
var canvasWidth = windowWidth >= 1328 ? 1328 : windowWidth;
var PARAMS = {
    'debug': false,
    'canvasWidth': canvasWidth,
    'canvasHeight': 225,
    'dotRadius': 1,
    'xFieldOffset': 0,
    'yFieldOffset': 0,
    'xStepCoefficient': 20,
    'yStepCoefficient': 40,
    'step': 10,
    'rowsCount': 6,
    'columnsCount': 45,
    'length': 18,
    'anchorY': 350,
    'corner': 17.5
};

var Line =
    /*#__PURE__*/
    function () {
        function Line(params) {
            _classCallCheck(this, Line);

            this.p1 = {
                'x': params.p1.x,
                'y': params.p1.y
            };
            this.p2 = {
                'x': params.p2.x,
                'y': params.p2.y
            };
            this.color = params.color;
            this.opacity = params.opacity;
        }

        _createClass(Line, [{
            key: "draw",
            value: function draw() {
                this.distance = Math.sqrt(Math.pow(this.p1.x - this.p2.x, 2) + Math.pow(this.p1.y - this.p2.y, 2));
                this.pointsCount = Math.round(this.distance / PARAMS.dotRadius / 4);
                this.deltaX = (this.p2.x - this.p1.x) / (this.pointsCount - 1);
                this.deltaY = (this.p2.y - this.p1.y) / (this.pointsCount - 1);
                ctx.beginPath();
                ctx.fillStyle = this.color;
                ctx.globalAlpha = this.opacity;

                for (var i = 0; i < this.pointsCount; i++) {
                    var x = this.p1.x + this.deltaX * i,
                        y = this.p1.y + this.deltaY * i;
                    ctx.arc(x, y, PARAMS.dotRadius, 0, Math.PI + Math.PI * 2 / 2, true);
                }

                ctx.fill();
                ctx.globalAlpha = 1;
            }
        }, {
            key: "updateState",
            value: function updateState() {
                var dx = mouse.x - windowWidth / 2;
                var dy = mouse.y - PARAMS.canvasHeight + PARAMS.anchorY;
                var d = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                var p = PARAMS.length / d;

                if (Math.abs(dx * p) > PARAMS.corner) {
                } else {
                    this.p2.x = this.p1.x + dx * p;
                    this.p2.y = this.p1.y - Math.abs(dy * p);
                }
            }
        }]);

        return Line;
    }();

$(document).ready(function () {

    if (document.getElementById("lines")) {
        start();
        generateLines();
        $(document).on('mousemove', function (event) {
            clearInterval(timeout);
            isMoving = true;
            mouse.x = event.clientX;
            mouse.y = event.clientY;
            timeout = setTimeout(function () {
                isMoving = false;
            }, 500);
        });
        requestAnimationFrame(update);
    }
});

function start() {
    canvas = document.getElementById("lines");
    ctx = canvas.getContext("2d");
    canvas.width = PARAMS.canvasWidth;
    canvas.height = PARAMS.canvasHeight;

    if (PARAMS.debug === false) {
    }
}

function generateLines() {
    var x1, y1, x2, y2;

    for (var i = 0; i < PARAMS.rowsCount; i++) {
        for (var j = 0; j < PARAMS.columnsCount; j++) {
            if (j % 2 === 0) {
                x1 = j * PARAMS.xStepCoefficient + j * PARAMS.step + PARAMS.xFieldOffset;
                y1 = i * PARAMS.yStepCoefficient + PARAMS.yFieldOffset;
                x2 = j * PARAMS.xStepCoefficient + j * PARAMS.step + PARAMS.xFieldOffset;
                y2 = i * PARAMS.yStepCoefficient + PARAMS.length + PARAMS.yFieldOffset;
            } else {
                x1 = j * PARAMS.xStepCoefficient + j * PARAMS.step + PARAMS.xFieldOffset;
                y1 = i * PARAMS.yStepCoefficient + PARAMS.step + PARAMS.yFieldOffset;
                x2 = j * PARAMS.xStepCoefficient + j * PARAMS.step + PARAMS.xFieldOffset;
                y2 = i * PARAMS.yStepCoefficient + PARAMS.length + PARAMS.step + PARAMS.yFieldOffset;
            }

            var params = {};
            params.p1 = {
                'x': x1,
                'y': y1
            };
            params.p2 = {
                'x': x2,
                'y': y2
            };
            params.color = '#FFFFFF';
            params.opacity = 0.2;
            var line = new Line(params);
            line.draw();
            lines.push(line);
        }
    }
}

function update() {
    if (isMoving) {
        drawAll();
    }

    requestAnimationFrame(update);
}

function drawAll() {
    ctx.clearRect(0, 0, windowWidth, windowHeight);

    for (var k = 0; k < lines.length; k++) {
        lines[k].updateState();
        lines[k].draw();
    }
}

var tab = $('.map__tabs').find('li');
$('.map__tabs li').on('click', function () {
    if ($('.map__tabs li').hasClass('active')) {
        $('.map__tabs li').removeClass('active');
    }
    ;
    $(this).addClass('active');
    var tabId = $(this).attr('class').substr(4, 2);
    $('.country').removeClass('active');
    $('#' + tabId).addClass('active');
    $('.cpt').removeClass('active-cpt');
    $('.' + tabId).addClass('active-cpt');
    updateMapData(tabId);
    if (tabId == 'ru') {
        $('.map__tabs li').addClass('white');
    } else {
        $('.map__tabs li').removeClass('white');
    }


    var posX = $('.cpt.' + tabId).attr('cx'),
        posY = $('.cpt.' + tabId).attr('cy');

    $('.tab-' + tabId).addClass('active');
    updateMapData(tabId);

    // Remove any old one
    $(".ripple").remove();

    // Setup
    var buttonWidth = $('.map').width(),
        buttonHeight = $('.map').height();

    // Add the element
    $('.map').prepend("<span class='ripple'></span>");


    // Make it round!
    if (buttonWidth >= buttonHeight) {
        buttonHeight = buttonWidth;
    } else {
        buttonWidth = buttonHeight;
    }


    // Add the ripples CSS and start the animation
    $(".ripple").css({
        width: buttonWidth,
        height: buttonHeight,
        top: parseInt((-buttonHeight / 2)) + parseInt(posY),
        left: parseInt((-buttonWidth / 2)) + parseInt(posX)
    }).addClass("rippleEffect");

});

$('.country').on('click', function () {
    var idi = $(this).attr('id');
    $('.country').removeClass('active');
    $('#' + idi).addClass('active');
    $('.cpt').removeClass('active-cpt');
    $('.' + idi).addClass('active-cpt');
    if ($('li').hasClass('active')) {
        $('li').removeClass('active');
    }
    ;

    var posX = $('.cpt.' + idi).attr('cx'),
        posY = $('.cpt.' + idi).attr('cy');

    $('.tab-' + idi).addClass('active');
    updateMapData(idi);

    if (idi == 'ru') {
        $('.map__tabs li').addClass('white');
    } else {
        $('.map__tabs li').removeClass('white');
    }


    // Remove any old one
    $(".ripple").remove();

    // Setup
    var buttonWidth = $('.map').width(),
        buttonHeight = $('.map').height();

    // Add the element
    $('.map').prepend("<span class='ripple'></span>");


    // Make it round!
    if (buttonWidth >= buttonHeight) {
        buttonHeight = buttonWidth;
    } else {
        buttonWidth = buttonHeight;
    }


    if ($(window).width() < 1440) {
        posX = posX * $(window).width() / 1440;
        posY = posY * $('.map').height() / 904;
    }
    // Add the ripples CSS and start the animation
    $(".ripple").css({
        width: buttonWidth,
        height: buttonHeight,
        top: parseInt((-buttonHeight / 2)) + parseInt(posY),
        left: parseInt((-buttonWidth / 2)) + parseInt(posX)
    }).addClass("rippleEffect");
    console.log(posY);
});


function updateMapData(id) {
    Object.keys(mapData[id]).forEach(function (key) {
        $('.map-content [data-type=' + key + ']').text(mapData[id][key]);
    });
}


$(function () {
    if ($('.select__options ul li').hasClass('selected')) {
        $('.select .select__country').text($('.select__options li.selected').text());

    } else {
        $('.select .select__country').text($('.select__options li:first-child').text());
    }
    $('.select').on('click', function () {

        $('.select__options').toggleClass('visible');
        $('.select__sub > i').toggleClass('rotate');


    });
    $('.select__options ul li').on('click', function () {


        $('.selected').removeClass('selected');
        $('.map__slogan').css('bottom', ('0'));
        var SelectId = $(this).attr('class').substr(7, 2);
        $(this).addClass('selected');
        $('.map-mobile').attr('class', 'map-mobile ' + SelectId);
        $('.select .select__country').text($(this).text());
        $('.map-content').css('display', 'block');

        updateMapData(SelectId);

    });
});


$('.mobile-menu__nav a').on('click', function () {
    $('.mobile-menu').removeClass('is-active');
    body.removeClass('no-scroll');
});
$('.lang-btn').on('click', function () {
    $('.lang-btn__hide').toggleClass('is-active');
    $('.lang-btn__sub i').toggleClass('is-active');
});
$('.about__content a').on('click', function () {
    $('.about__open').css('opacity', '0');

    $('.about__more-content').slideDown(1000);

    $('.relative').css('background', '#fff');
    $('.about__close').slideDown(1000);


});

$('.about__close a').on('click', function () {
    $('.about__more-content').slideUp(1000);
    $('.about__close').slideUp(1000);
    $('.about__open').css('opacity', '1');
    setTimeout(function () {
        $('.relative').css('background', 'none');
    }, 1100);
});


$(document).ready(function () {
    $('.js-send').on('click', function (e) {
        e.preventDefault();
        var text = $('.js-text');
        var mail = $('.js-mail');
        var checkbox = $('.js-checkbox');
        var orgValid = validateText(text[0]);
        var nameValid = validateText(text[1]);
        var textValid = validateText(text[2]);
        var emailValid = validateEmail(mail.val());
        var checkboxValid = validateCheckbox(checkbox);
        if (orgValid && nameValid && textValid && emailValid && checkboxValid) {
            var form = $(this).parents('form');
            var data = form.serialize();
            $.ajax({
                url: form.attr('action'),
                method: 'post',
                dataType: 'json',
                data: data,
                success: function (response) {
                    var res = '<div class=b-popup__title></div>';
                    res += '<div class=b-popup__title>' + response.msg + '</div>'
                    res += '<a class=b-popup__close href=javascript:PopUpHide(\'popupResult\')>' + '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="16.3419" height="2.04274" transform="matrix(0.707103 0.707111 -0.707103 0.707111 1.44446 0)" fill="#5B5C64"></rect> <rect width="16.3419" height="2.04274" transform="matrix(0.707103 -0.707111 0.707103 0.707111 0.00012207 11.5557)" fill="#5B5C64"></rect> </svg>' + '                    </a>';
                    $('#popupResult .b-popup__content').html(res);
                    form.trigger('reset'); // $('.b-popup__content').css('min-height', 'unset');                    // $('.b-popup__content').addClass('success');                    // $('.b-popup__content').html(res);
                    PopUpHide('popup1');
                    dataLayer.push({'event':'Feedback', 'eventAction':'send'});
                    PopUpShow('popupResult');
                }
            }); // отправить запрос
        } else {
            if (!orgValid) {
                text[0].classList.add('error');
            }
            if (!nameValid) {
                text[1].classList.add('error');
            }
            if (!textValid) {
                text[2].classList.add('error');
            }
            if (!emailValid) {
                mail.addClass('error');
            }
            if (!checkboxValid) {
                $('.js-checkbox').css('border-color', '#ef426f');
            }
        }
    });
});
$('.b-popup__input input').on('focus', function () {
    $(this).removeClass('error');
});
$('.b-popup__input textarea').on('focus', function () {
    $(this).removeClass('error');
})

function validateText(field) {
    return field.value.length > 0;
}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}


function validateCheckbox(check) {
    return (check.is(':checked'));
}

function PopUpShow(popup) {
    $("#" + popup).addClass('active');
    $(body).addClass('no-scroll');
}

function PopUpHide(popup) {
    $("#" + popup).removeClass('active');
    $(body).removeClass('no-scroll');
}

$('.b-popup__overlay').on('click', function () {
    $('.b-popup').removeClass('active');
    $(body).removeClass('no-scroll');
});

$('.advantages__item-wrapper').hover(function () {
    var dots = anime({
        targets: $(this).find('.dots')[0],
        height: '100%',
        easing: 'linear',
        duration: 800,
    });
}, function () {
    var dots1 = anime({
        targets: '.advantages__item-wrapper .dots',
        height: 0,
        easing: 'linear',
        duration: 800,
    });
});
if ($(window).width() < 900) {
    $('.swiper-desktop').remove();
} else {
    $('.swiper-mobile').remove();
}
